<ion-header>
  <ion-toolbar class="thin-toolbar background-background" mode="ios">
    <frontend-header routeId="waitlist"></frontend-header>
  </ion-toolbar>
</ion-header>

<ion-content [forceOverscroll]="false">
  <frontend-pull-refresh></frontend-pull-refresh>

  <div class="d-flex estimated-wait align-items-center justify-content-between">
    <div *ngIf="displayEstimatedWait">
      <div class="col-12 pt-2">
        <h5>
          <span class="lead text-uppercase">Estimated current wait: </span>
          <span *ngIf="!showEstimatedWait">{{noEstimatedWaitMessage}}</span>
          <span *ngIf="showEstimatedWait && onlyOneWaitValue">
          {{waitingParties[waitValues.indexOf(1)].wait | trTimeDelta}}
        </span>
          <ul class="list-inline d-inline-block mb-0" *ngIf="showEstimatedWait && !onlyOneWaitValue">
            <li class="list-inline-item" *ngFor="let item of waitingParties | slice:0:5; index as i">
            <span *ngIf="waitValues[i] > 0" class="badge badge-info">
              <span class="bi bi-person-fill"></span>
              <span>{{item.name}}: </span>
              <span>{{item.wait | trTimeDelta}}</span>
            </span>
            </li>
          </ul>
        </h5>
      </div>
    </div>

    <div
      class="search-row"
      [class.w-25]="displayEstimatedWait"
      [class.w-100]="!displayEstimatedWait"
    >
      <tablesready-search-bar
        #searchBarRef
        [placeholder]="'Search ' + location?.displayOptions?.labels?.customer_plural || 'customers'"
        (search)="updateSearchQuery($event)"
      >
      </tablesready-search-bar>
    </div>
  </div>

  <div class="overflow">
    <table *ngIf="location && parties && parties.length" class="table table-striped tr-table table-bottom-spacer"
           infiniteScroll
           [infiniteScrollDisabled]="disableScroll"
           [infiniteScrollDistance]="3"
           (scrolled)="loadMore()"
           [ngClass]="{'table-sm':displayCompact}">
      <thead>
      <tr>
        <th *ngIf="location.waitFields.position_in_line">
          Pos
        </th>
        <th>
          <tablesready-sortable-column
            [sortBy]="sortBy"
            column="name"
            [title]="location?.displayOptions?.labels?.customer || 'customer'"
            [orderAscending]="sortReverse"
            (orderBy)="orderBy($event)"
          ></tablesready-sortable-column>
        </th>
        <th *ngIf="waitFields?.size"
            joyrideStep="Sort"
            [title]="guiderService.getGuidTitle('Sort')"
            [text]="guiderService.getGuidText('Sort')">
          <tablesready-sortable-column
            [sortBy]="sortBy"
            column="size"
            title="size"
            [orderAscending]="sortReverse"
            (orderBy)="orderBy($event)"
          ></tablesready-sortable-column>
        </th>
        <th *ngIf="location?.waitFields?.note_column">
          <tablesready-sortable-column
            [sortBy]="sortBy"
            column="note"
            title="notes"
            [orderAscending]="sortReverse"
            (orderBy)="orderBy($event)"
          ></tablesready-sortable-column>
        </th>
        <th *ngIf="location?.serviceSettings?.enabled && location?.serviceSettings?.showOnPages && services.length > 0">
          <tablesready-sortable-column
            [sortBy]="sortBy"
            column="service"
            [title]="location?.serviceSettings?.label || 'service'"
            [orderAscending]="sortReverse"
            (orderBy)="orderBy($event)"
          ></tablesready-sortable-column>
        </th>
        <th *ngIf="location?.resourceSettings?.enabled && location?.resourceSettings?.showOnPages && resources.length > 0">
          <tablesready-sortable-column
            [sortBy]="sortBy"
            column="resource"
            [title]="location?.resourceSettings?.label || 'resource'"
            [orderAscending]="sortReverse"
            (orderBy)="orderBy($event)"
          ></tablesready-sortable-column>
        </th>
        <th *ngIf="waitFields?.quoted_time">
          <tablesready-sortable-column
            [sortBy]="sortBy"
            column="quoted_time"
            [title]="location?.displayOptions?.labels?.quoted || 'quoted time'"
            [orderAscending]="sortReverse"
            (orderBy)="orderBy($event)"
          ></tablesready-sortable-column>
        </th>
        <th *ngIf="waitFields?.arrival_time">
          <tablesready-sortable-column
            [sortBy]="sortBy"
            column="checkin_time"
            title="arrival"
            [orderAscending]="sortReverse"
            (orderBy)="orderBy($event)"
          ></tablesready-sortable-column>
        </th>
        <th *ngIf="waitFields?.wait_time">
          <tablesready-sortable-column
            [sortBy]="sortBy"
            column="checkin_time"
            title="wait"
            [orderAscending]="sortReverse"
            (orderBy)="orderBy($event)"
          ></tablesready-sortable-column>
        </th>
        <ng-container *ngIf="showCustomFieldsData">
          <ng-container *ngFor="let customField of user.location.partyFields">
            <th *ngIf="customField.enabled && customField.visibility.private.view" [innerText]="customField.name"></th>
          </ng-container>
        </ng-container>
        <th joyrideStep="Notify"
            [title]="guiderService.getGuidTitle('Notify')"
            [text]="guiderService.getGuidText('Notify')"
            (prev)="onPrev('AddEditParty')">
          Notify
        </th>
        <th joyrideStep="Actions"
            [title]="guiderService.getGuidTitle('Actions')"
            [text]="guiderService.getGuidText('Actions')">
          Actions
        </th>
      </tr>
      </thead>
      <tbody>
      <ng-container *ngFor="let party of parties; index as i; trackBy: trackById">
        <tr [@markParty]="party.isHidden ? 'collapsed' : 'expanded'">
          <td *ngIf="location.waitFields.position_in_line">
            {{i+1}}
          </td>
          <td>
            <div class="d-flex flex-column justify-content-center align-items-start">
              <div class="d-flex flex-row justify-content-start align-items-center">
                <span class="lead name">{{party?.name}}</span>&nbsp;
                <tablesready-party-badge
                  [party]="party"
                  [showTypeBadge]="party.type === partyTypes.reservation || party.type === partyTypes.togo"
                ></tablesready-party-badge>
                <shared-badge
                  *ngIf="unpaid(party)"
                  [label]="'Unpaid'"
                  [class]="'badge badge-pill badge-danger'"
                ></shared-badge>
                <shared-badge
                  *ngIf="paid(party)"
                  [label]="'Paid'"
                  [class]="'badge badge-pill badge-success'"
                ></shared-badge>
              </div>

              <div class="d-flex flex-column align-items-start">
                <span *ngIf="unpaid(party)" class="d-flex flex-row font-weight-bold">
              <span class="pr-1">
                Holding for:
              </span>
              <tablesready-countdoun-timer [milliseconds]="getRemainingSecondsToPay(party.created_time)"></tablesready-countdoun-timer>
            </span>

                <span *ngIf="paid(party) && party.stripeData?.paymentLink">
              <a class="text-link" [href]="party.stripeData?.paymentLink" target="_blank">Manage Payment</a>
            </span>
                <span *ngIf="party?.loyalty_count >= 1">
              |
              <span class="secondary">{{party?.loyalty_count}} recent visits</span>
            </span>
                <span *ngIf="party?.phone"  data-dd-privacy="mask">
              {{ party?.phone | trTel:location?.country:'custom' }}
            </span>
                <span *ngIf="party?.note && !location?.waitFields?.note_column">
              <span
                *ngIf="party?.source === partySources.square
                  && location?.integrations?.squareOptions?.showOrderItems
                  && isArray(party?.note)"
              >
                <ul class="list-unstyled mb-1">
                  <li *ngFor="let item of party.note">{{item}}</li>
                </ul>
              </span>
              <span
                *ngIf="!(party?.source === partySources.square
                  && location?.integrations?.squareOptions?.showOrderItems
                  && isArray(party?.note))"
              >{{ isArray(party?.note) ? party?.note.join(', ') : party?.note}}</span>
            </span>
              </div>
            </div>
          </td>

          <td *ngIf="waitFields?.size">
            <span class="d-xs-inline d-sm-none">Size: </span>
            {{party?.size}}
          </td>

          <td *ngIf="location?.waitFields?.note_column">
            <span class="d-xs-inline d-sm-none">Notes: </span>
            <span
              *ngIf="party?.source === partySources.square
                && location?.integrations?.squareOptions?.showOrderItems
                && isArray(party?.note)"
            >
                    <ul class="list-unstyled mb-1">
                        <li *ngFor="let item of party.note">{{item}}</li>
                    </ul>
                </span>
            <span
              *ngIf="!(party?.type === partyTypes.order
                && party.source === partySources.square
                && location?.integrations?.squareOptions?.showOrderItems
                && isArray(party?.note))"
            >{{ isArray(party?.note) ? party?.note.join(', ') : party?.note}}</span>
          </td>

          <td *ngIf="location?.serviceSettings?.enabled && location?.serviceSettings?.showOnPages && services.length > 0">
            <tablesready-model-name-display [id]="party?.services" [models]="services"></tablesready-model-name-display>
          </td>
          <td *ngIf="location?.resourceSettings?.enabled && location?.resourceSettings?.showOnPages && resources.length > 0">
            <tablesready-model-name-display [id]="party?.resources" [models]="resources"></tablesready-model-name-display>
          </td>

          <td *ngIf="waitFields?.quoted_time">
            <tablesready-waitlist-quoted-time
              [party]="party"
              [label]="location?.displayOptions?.labels?.quoted"
              [timezone]="location.timezone"
            ></tablesready-waitlist-quoted-time>
          </td>
          <td *ngIf="waitFields?.arrival_time">
            <span class="d-xs-inline d-sm-none">Arrival: </span>
            <ng-container *ngIf="party?.checkin_time; else notChecked" >
              {{party?.checkin_time | trDateFormat:'h:mm a': this.location.timezone}}
            </ng-container>
            <ng-template #notChecked>
              Not checked in
            </ng-template>
          </td>
          <td *ngIf="waitFields?.wait_time">
            <span class="d-xs-inline d-sm-none">Wait: </span>
            {{ (party?.checkin_time ? (now - party?.checkin_time) : 0) | trTimeDelta}}
          </td>

          <ng-container *ngIf="showCustomFieldsData">
            <ng-container *ngFor="let customField of user.location.partyFields">
              <ng-container *ngIf="customField.enabled && customField.visibility.private.view && displayCustomFieldCell(party, customField.id)">
                <td
                  *ngIf="customField.type !== fieldTypes.tel"
                  [innerHTML]="party.customFields[customField.id]"
                ></td>

                <td
                  *ngIf="customField.type === fieldTypes.tel"
                  [innerText]="party.customFields[customField.id] ? (party.customFields[customField.id] | trTel:location.country:'custom') : ''"
                ></td>
              </ng-container>
            </ng-container>
          </ng-container>

          <td class="notify">
            <div class="d-flex flex-column">
              <div *ngIf="!party?.checkin_time">
                <button class="btn btn-success btn-check-in text-nowrap" (click)="checkIn(party)" angularticsCategory="waitlist"
                        angulartics2On="click" angularticsAction="checked in reservation" id="checkin-party-{{i}}">
                  <i class="bi bi-play-fill"></i> Check In
                </button>
              </div>
              <tablesready-waitlist-notify
                [timezone]="user.location.timezone"
                [party]="party"
                [index]="i"
                [notificationTime]="user.location.displayOptions.notificationTime"
                [voicePageNotificationEnabled]="user.location.messages.voicePageNotification.enabled"
                [notifyActions]="notifyActions"
                [isMobile]="isHandset"
              >
              </tablesready-waitlist-notify>
            </div>
          </td>
          <td>
            <tablesready-waitlist-actions
              [party]="party"
              [index]="i"
              [callbacks]="actionsCallbacks"
              [isMobile]="isHandset"
            ></tablesready-waitlist-actions>
          </td>
        </tr>
      </ng-container>
      </tbody>
    </table>
  </div>

  <div class="col-12 waitlist-empty" *ngIf="(!parties || parties.length === 0) && location">
    <a [routerLink]="[]" [class.disabled]="!schedule?.length" (click)="addEditParty()">
      <img src="assets/img/add_to_waitlist.svg" alt="Your waitlist is empty. Add a party to get started.">
    </a>
    <h5>No waiting {{location?.displayOptions?.labels?.customer_plural}}.</h5>
    <p><a [routerLink]="[]" [class.disabled]="!schedule?.length" (click)="addEditParty()">Add a {{location?.displayOptions?.labels?.customer}} to get started.</a></p>
  </div>

  <div class="add-new" >
    <span class="add-new-blocker" slot="fixed">
      <button type="button"
              class="btn btn-accent btn-circle"
              (click)="addEditParty()"
              id="addEditParty-button"
              joyrideStep="AddParty"
              [disabled]="!schedule?.length"
              [title]="guiderService.getGuidTitle('AddParty')"
              [text]="guiderService.getGuidText('AddParty')"
              (next)="onNext('AddEditParty')"
              (prev)="onPrev()">
        <tr-icon [icon]="icon.plus" [size]="size.extraLarge" [color]="color.white"></tr-icon>
      </button>
    </span>
  </div>

  <footer class="footer shadow-sm" *ngIf="location?.displayOptions && location.displayOptions?.footer">
    <div class="d-flex align-items-center overflow-auto flex-nowrap w-100">
      <button class="btn btn-sm rounded-pill" 
        [ngClass]="{'btn-info': isCurrentPartiesFilterActive, 'btn-outline-info': !isCurrentPartiesFilterActive}"
        (click)="isCurrentPartiesFilterActive = !isCurrentPartiesFilterActive; filterBySize(null)">
        <strong class="me-2">
          <span class="d-none d-sm-inline">Current </span>
          <span>{{location?.displayOptions?.labels?.customer_plural || 'customers' | titlecase}}: </span>
        </strong>
        <span>{{guestCount}}</span>
      </button>
      <ul class="list-inline d-inline-block mb-0 ms-2">
          <ng-container *ngIf="waitingParties">
            <li class="list-inline-item" *ngFor="let item of waitingParties | slice:0:5">
              <button class="btn btn-sm rounded-pill"
                [ngClass]="{'btn-info': currentSizeFilter === item.name, 'btn-outline-info': currentSizeFilter !== item.name}"
                (click)="filterBySize(currentSizeFilter === item.name ? null : item.name)">
                  <span class="bi bi-person-fill me-1"> </span>
                  <span>{{item.name}}: </span>
                  <span>{{item.count}}</span>
                </button>
            </li>
          </ng-container>
        </ul>
    </div>
  </footer>

  <joyrideStep joyrideStep="Final"
               [title]="guiderService.getGuidTitle('Final')"
               [text]="guiderService.getGuidText('Final')"
               stepPosition="center"></joyrideStep>

  <ion-infinite-scroll (ionInfinite)="onIonInfinite($event)">
    <ion-infinite-scroll-content></ion-infinite-scroll-content>
  </ion-infinite-scroll>
</ion-content>
